import { ZoomIn, ZoomOut } from 'lucide-react';

export default function ZoomToolbar({
  stageScale,
  showGrid,
  onZoomIn,
  onZoomOut,
  onResetZoom,
  onShowGridChange,
}) {
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2 shadow-sm">
      <span className="text-sm font-medium text-gray-700">Page zoom:</span>
      <button
        type="button"
        onClick={onZoomOut}
        className="p-1.5 bg-white rounded border border-gray-300 hover:bg-gray-100"
        title="Zoom Out"
      >
        <ZoomOut size={14} />
      </button>
      <span className="text-sm text-gray-600 min-w-[36px] text-center">
        {Math.round(stageScale * 100)}%
      </span>
      <button
        type="button"
        onClick={onZoomIn}
        className="p-1.5 bg-white rounded border border-gray-300 hover:bg-gray-100"
        title="Zoom In"
      >
        <ZoomIn size={14} />
      </button>
      <button
        type="button"
        onClick={onResetZoom}
        className="px-2 py-1 bg-white rounded border border-gray-300 hover:bg-gray-100 text-xs"
      >
        Reset (30%)
      </button>
      <label className="ml-auto flex items-center gap-2 text-xs font-medium text-slate-600">
        <input
          type="checkbox"
          checked={showGrid}
          onChange={(event) => onShowGridChange(event.target.checked)}
          className="rounded"
        />
        Show alignment grid
      </label>
    </div>
  );
}
